export const OVERVIEW_TAB = 'Overview',
  PHASES_TAB = 'Plan and phases',
  UPDATES_TAB = 'Updates',
  REPOSITORY_TAB = 'Repository',
  FINANCIAL_TAB = 'Funding and cost',
  RISK_TAB = 'Risk registry',
  MANUAL_URL = 'https://newgo.wfp.org/documents/engineering-construction-manual';
